// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e2ab287c","455":"b5941035","762":"913d9dc6","977":"bb98ef03"}[chunkId] + ".chunk.js";
};